const serversTab = {
    LOAD_SERVERS: "LOAD_SERVERS",
    LOADED_SERVERS: "LOADED_SERVERS",
    ERROR_LOADING_SERVERS: "ERROR_LOADING_SERVERS",
    ERROR_DELETING_SERVER: "ERROR_DELETING_SERVER",
};

export default serversTab;
